import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { FrontDeskBriefing } from '@lemontaigu/pms-core';
import { SupabaseVegaFrontDeskBriefing } from '@lemontaigu/pms-adapters';
import { supabase } from './supabase.js';

/**
 * The C4 composition root for the team's « Arrivées · Départs » list — the one
 * place in this app that binds the Supabase client to the FrontDeskBriefing
 * port. The view depends on the interface only.
 *
 * Separate from StaffProvider on purpose: that root is C3 (workforce); this is
 * C4 (reservations/PMS), and an app is a composition of contexts, each wired at
 * its own root (ARCHITECTURE.md §2, R8).
 */
const FrontDeskContext = createContext<FrontDeskBriefing | null>(null);

export function FrontDeskProvider({ children }: { children: ReactNode }) {
  const briefing = useMemo(() => new SupabaseVegaFrontDeskBriefing(supabase), []);
  return <FrontDeskContext.Provider value={briefing}>{children}</FrontDeskContext.Provider>;
}

export function useFrontDesk(): FrontDeskBriefing {
  const v = useContext(FrontDeskContext);
  if (!v) throw new Error('useFrontDesk outside <FrontDeskProvider>');
  return v;
}
